export enum PropertyFormEventEnum {
    // propertyIframeWindow--保存属性表单
    PROPERTY_FORM_WINDOW_SAVE = "propertyForm.event.save",
    // propertyIframeWindow--重置为默认表单
    PROPERTY_FORM_WINDOW_RESET = "propertyForm.event.reset",
    // propertyIframeWindow--重置Token
    PROPERTY_FORM_WINDOW_RESET_TOKEN = "propertyForm.event.resetToken",
    // propertyIframeWindow--属性表单正在执行初始化
    PROPERTY_FORM_WINDOW_ON_INIT = "propertyForm.lifeCycle.onInit",
    // propertyIframeWindow--属性表單視圖初始化完成
    PROPERTY_FORM_WINDOW_AFTER_VIEW_INIT = "propertyForm.lifeCycle.afterViewInit",
    // propertyIframeWindow--Token过期
    PROPERTY_FORM_WINDOW_ON_EXPIRED = "propertyForm.lifeCycle.onExpired",
    // propertyIframeWindow--属性表单页面尺寸变化
    PROPERTY_FORM_WINDOW_ON_RESIZE = "propertyForm.lifeCycle.onResize",
    // propertyIframeWindow--属性表单运行过程中产生了异常
    PROPERTY_FORM_WINDOW_ON_ERROR = "propertyForm.lifeCycle.onError",
    // propertyIframeWindow--属性表单验证_开启
    PROPERTY_FORM_WINDOW_LIFE_CYCLE_ON_VALIDATE = "propertyForm.lifeCycle.onValidate",
    // propertyIframeWindow--属性表单验证_关闭
    PROPERTY_FORM_WINDOW_LIFE_CYCLE_AFTER_VALIDATE = "propertyForm.lifeCycle.afterValidate",
    // propertyIframeWindow--调用超时
    PROPERTY_FORM_WINDOW_ON_TIMEOUT = "propertyForm.lifeCycle.onTimeout",
    // propertyIframeWindow--save事件回调
    PROPERTY_FORM_WINDOW_AFTER_SAVE = "propertyForm.event.afterSave",
    // propertyIframeWindow--Reset事件回调
    PROPERTY_FORM_WINDOW_AFTER_RESET = "propertyForm.event.afterReset",
    // propertyIframeWindow--ResetToken事件回调
    PROPERTY_FORM_WINDOW_AFTER_RESET_TOKEN = "propertyForm.event.afterResetToken",
    // propertyIframeWindow--查询表单属性键值对
    PROPERTY_FORM_WINDOW_GET_KEY_VALUE = "propertyForm.event.getKeyValue",
    // propertyIframeWindow--GetKeyValue事件回调
    PROPERTY_FORM_WINDOW_AFTER_GET_KEY_VALUE = "propertyForm.event.afterGetKeyValue",
    // propertyIframeWindow--propertyForm.event.validate
    PROPERTY_FORM_WINDOW_VALIDATE = "propertyForm.event.validate",
    // propertyIframeWindow--propertyForm.event.validate
    PROPERTY_FORM_WINDOW_AFTER_VALIDATE = "propertyForm.event.afterValidate",
    // propertyIframeWindow--查询表单完整数据
    PROPERTY_FORM_WINDOW_GET = "propertyForm.event.get",
    // propertyIframeWindow--查询表单完整数据-回调事件
    PROPERTY_FORM_WINDOW_AFTER_GET = "propertyForm.event.afterGet",
    // propertyIframeWindow--当前表单保存为SKU产品
    PROPERTY_FORM_WINDOW_SAVE_AS_SKU = "propertyForm.event.saveAsSku",
    // propertyIframeWindow--当前表单保存为SKU产品-回调函数
    PROPERTY_FORM_WINDOW_AFTER_SAVE_AS_SKU = "propertyForm.event.afterSaveAsSku"

}